(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (function () {
    document.addEventListener('DOMContentLoaded', function () {
      const searchElement = document.querySelector('.header__search');
      const searchWrapper = document.querySelector('.header__search-nav-wr');
      const iconsContainer = document.querySelector('.header__icons');

      if (!searchElement || !searchWrapper || !iconsContainer) return;

      function moveSearch() {
        const width = window.innerWidth;

        if (width > 990 && searchElement.parentElement !== iconsContainer) {
          iconsContainer.appendChild(searchElement);
        } else if (width < 900 && searchElement.parentElement !== searchWrapper) {
          searchWrapper.appendChild(searchElement);
        }
      }

      window.addEventListener('resize', moveSearch);
      moveSearch();
    });
  })();

  (function () {
    const stickyHeader = document.querySelector('.header-wrapper');
    const transparentHeader = document.querySelector('.transparent-header');

    if (!stickyHeader || !transparentHeader) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            stickyHeader.classList.add('under-dark-element');
          } else {
            stickyHeader.classList.remove('under-dark-element');
          }
        });
      },
      {
        root: null,
        threshold: 0,
        rootMargin: `-${stickyHeader.offsetHeight}px 0px 0px 0px`,
      }
    );
    observer.observe(transparentHeader);

    stickyHeader.addEventListener('mouseenter', () => {
      stickyHeader.classList.add('hover');
    });

    stickyHeader.addEventListener('mouseleave', () => {
      stickyHeader.classList.remove('hover');
    });
  })();

  (() => {
    function updateSubmenuHeight() {
      if (window.innerWidth <= 990) {
        document.querySelectorAll('header-menu > details > .header__submenu').forEach((submenu) => {
          submenu.style.height = '';
        });
        return;
      }

      const firstSection = document.querySelector('#MainContent .section');
      if (!firstSection) return;

      const sectionHeight = firstSection.getBoundingClientRect().height - 44;
    }

    document.addEventListener('DOMContentLoaded', updateSubmenuHeight);
    window.addEventListener('resize', updateSubmenuHeight);
  })();

  } catch(e) { console.error(e); }
})();
})();
